import React from "react";

import { useContext } from "../Context";
import Loader from "../../../ui/Loader";

export default function Wait() {
  const { state } = useContext();

  return (
    <div className="ibox-content mt20">
      <Loader state={state.policy == null} />
    </div>
  );
}
